import React from 'react';

import { EmptyState } from '@/components/atoms/EmptyState';
import { useTranslator } from '@/hooks/useTranslator';

const compactContainerStyles = {
  flex: 1,
  minHeight: 200,
  backgroundColor: 'custom.OffWhite',
  borderRadius: 2,
  px: 7,
};

export const NoCustomerActivityResultsView: React.FC = (): React.ReactElement => {
  const tr = useTranslator();

  return (
    <EmptyState.Container sx={compactContainerStyles}>
      <EmptyState.Title variant="h7">{tr('ZERO_RESULTS_FOUND')}</EmptyState.Title>
      <EmptyState.Message color="text.secondary">
        {tr('TRY_CHANGING_YOUR_APPLIED_FILTERS', tr('ACTIVITY').toLocaleLowerCase())}
      </EmptyState.Message>
    </EmptyState.Container>
  );
};
